import { render, staticRenderFns } from "./goods-vip-all-protocol-2024.vue?vue&type=template&id=2b65ab70&scoped=true"
import script from "./goods-vip-all-protocol-2024.vue?vue&type=script&lang=js"
export * from "./goods-vip-all-protocol-2024.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-all-protocol-2024.vue?vue&type=style&index=0&id=2b65ab70&prod&lang=scss"
import style1 from "./goods-vip-all-protocol-2024.vue?vue&type=style&index=1&id=2b65ab70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65ab70",
  null
  
)

export default component.exports